import React from 'react';
import { HowToVoteOutlined, PersonSearchOutlined, PublicOutlined } from '@mui/icons-material';
import { BrandedLoginPage, LoginBrand } from '@pages/USAJILILoginPage';

/** analytics.sdics.tech sign-in: the same admin and HQ accounts as RRI USAJILI. */
const ANALYTICS_BRAND: LoginBrand = {
  title: 'SDICS ANALYTICS',
  tagline: 'Registered and unregistered voters for every county, subcounty, division and location — and the diaspora.',
  features: [
    { icon: <HowToVoteOutlined />, title: 'Registered vs unregistered', text: 'From the IEBC roll and NRB records, down to each location.' },
    { icon: <PublicOutlined />, title: 'Diaspora & prisons', text: 'Every embassy, consulate and prison on the roll.' },
    { icon: <PersonSearchOutlined />, title: 'ID number search', text: 'Check the status of one ID or hundreds at once.' },
  ],
  home: '/analytics',
};

export const AnalyticsLoginPage: React.FC = () => <BrandedLoginPage brand={ANALYTICS_BRAND} />;

export default AnalyticsLoginPage;
